module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"overflow-y__auto dictionary-uploader-form\">\n	<div class=\"title\" name=\"action\"></div>\n	<div name=\"content\"></div>\n\n	<div name=\"preloader\" class=\"cell__abs preloader\">\n		<img src=\"/images/preloader.gif\"/>\n	</div>\n</div>\n\n<style>\n	.dictionary-uploader-form {\n		width: 640px;\n		height: 610px;\n		padding: 10px;;\n	}\n\n	.dictionary-uploader-form .preloader {\n		background: #ffffff;\n		display: none;\n	}\n\n	.dictionary-uploader-form .preloader img {\n		position: absolute;\n		left: 50%;\n		top: 50%;\n		margin-left: -64px;\n		margin-top: -64px;\n	}\n\n	.dictionary-uploader-form .warning {\n		color: red;\n	}\n\n	.dictionary-uploader-form .title {\n		font-weight: bold;\n		font-size: 1.2em;\n		margin-bottom: 12px;\n	}\n\n	.dictionary-uploader-form .row {\n		margin-bottom: 12px;\n	}\n\n	.dictionary-uploader-form .row label {\n		font-weight: bold;;\n	}\n\n	.dictionary-uploader-form table.columns {\n		min-width: 400px;\n	}\n\n	.dictionary-uploader-form table.columns td {\n		padding: 3px;\n	}\n\n	.dictionary-uploader-form table.columns thead td {\n		padding: 5px 3px;\n	}\n</style>")
  }
  return __output.join("");

}